import { MARKETING_HTML_LANG, hreflangPair, type MarketingLocale } from '../lib/marketingLocale'
import { MARKETING_DOCUMENT_PATHS, ogImagePath } from '../lib/marketingPages'
import { useSeo } from '../lib/seo'
import { PRIVACY } from '../content/legalCopy'
import { MarketingShell, MarketingTitle } from '../components/MarketingShell'
import { PrivacyBodyEn } from './legal/PrivacyBodyEn'
import { PrivacyBodyDe } from './legal/PrivacyBodyDe'

const PATHS = MARKETING_DOCUMENT_PATHS.privacy

/**
 * /privacy (EN) and /de/privacy (DE). See TermsPage for the pairing note; the
 * same rules apply.
 *
 * The policy is the document where the German version matters most and costs
 * least: it is a NOTICE rather than a contract, so there is no second-binding-
 * text risk, and the EDPB transparency guidelines expect a translation where
 * the controller targets speakers of that language. The prevailing-language
 * clause is section 15 in both versions all the same, so a reader is never left
 * guessing which text we stand behind.
 */
export function PrivacyPolicyPage({ locale }: { locale: MarketingLocale }) {
  const copy = PRIVACY[locale]

  useSeo({
    title: copy.meta.title,
    description: copy.meta.description,
    canonicalPath: PATHS[locale],
    lang: MARKETING_HTML_LANG[locale],
    alternates: hreflangPair(PATHS),
    ogImage: ogImagePath(PATHS[locale]),
  })

  return (
    <MarketingShell locale={locale}>
      <MarketingTitle>{copy.h1}</MarketingTitle>
      <p className="text-sm mb-4" style={{ color: '#6b6580' }}>{copy.updated}</p>
      {locale === 'de' ? <PrivacyBodyDe /> : <PrivacyBodyEn />}
    </MarketingShell>
  )
}

export default PrivacyPolicyPage
